import { vars } from '@etg/wings';
import { css } from '@eti/styles';

const linkStyles = css`
  color: ${vars.colors.links.default};

  &:hover {
    color: ${vars.colors.links.focus};
  }

  &:focus-visible {
    outline: 0.125rem solid ${vars.colors.focusRing};
  }
`;

const screenReadersOnlyStyles = css`
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const hideInternalLabelStyles = css`
  & label {
    clip-path: inset(50%);
    height: 1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`;

const focusStyles = css`
  outline: none;

  &:focus-visible {
    outline: 0.125rem solid ${vars.colors.focusRing};
    outline-offset: 0.1875rem;
  }
`;

export { linkStyles, focusStyles, screenReadersOnlyStyles };
